import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取菜单列表
  getMenuList(data) {
    const params = data
    return request({
      url: urlParams + '/menu/list',
      type: 'post',
      params: params
    })
  },
  // 新增或修改菜单
  addOrUpdataMenu(data) {
    const params = data
    return request({
      url: urlParams + '/menu/saveOrUpdate',
      type: 'post',
      params: params
    })
  },
  //  删除菜单
  delMenu(data) {
    const params = data
    return request({
      url: urlParams + '/menu/del',
      type: 'post',
      params: params
    })
  },
}